/**
 * Babel transpiler
 */
import * as Babel from "@babel/standalone"

/**
 * Compiler for version 2.6.11
 * @param {string} editorScript
 */
const compiler2_6_11 = ({ editorScript }) => {
	// Prepare for transpilation
	let scriptContent = `function __exportObject(){ return (${editorScript ? editorScript : `{}`}) }`

	let transpiledScriptContent
	try {
		transpiledScriptContent = Babel.transform(scriptContent, { presets: [["es2015", { modules: false }]] })?.code ?? ""
	} catch (e) {
		console.error(`Bable transpiler error`, e)
	}

	// Convert into component object
	let componentObject
	try {
		componentObject = new Function(`${transpiledScriptContent} return __exportObject()`)() // will return object
	} catch (e) {
		componentObject = {}
		console.error("Error in new Function", e)
	}

	return componentObject
}

/**
 * Versioned compilers
 */
const compilersProvider = {
	"2.6.11": compiler2_6_11
}

/**
 * compileEditorAstToVueTemplate
 * @param {string} editorScript
 * @param {string} version
 * @param {array} omitProperties - you can define what properties should become undefined on the vue object, it is helpful to e.g. remove created hook
 */
export default ({ editorScript = "", version = "", omitProperties = [] }) => {
	if (!editorScript) return {}

	const compiler = compilersProvider[version]
	if (!compiler) throw new Error(`There is no compiler for Vue of version ${version} available`)

	// Compile
	const compiled = compiler({ editorScript })

	// Omit properties
	omitProperties.forEach(property => {
		compiled[property] = undefined
	})

	return compiled
}
